const visibilityMap = {
	// document property: event name
	hidden: 'visibilitychange',
	mozHidden: 'mozvisibilitychange',
	msHidden: 'msvisibilitychange',
	webkitHidden: 'webkitvisibilitychange',
} as const;

const supportedHiddenKey = Object.keys(visibilityMap).find(
	(key) =>
		typeof document !== 'undefined' && typeof document[key as keyof Document] !== 'undefined',
);

export const supportedVisiblityEvent:
	| 'visibilitychange'
	| 'mozvisibilitychange'
	| 'msvisibilitychange'
	| 'webkitvisibilitychange' = visibilityMap[supportedHiddenKey as keyof typeof visibilityMap];

export const isPageVisible = (): boolean =>
	typeof document !== 'undefined' && !document[supportedHiddenKey as keyof Document];
